import { Component, Output, EventEmitter } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { FormGroup, FormControl } from '@angular/forms';
import { ImportConflict } from '../../../models/import-conflict';
import translateJson from "../../../../translate.json";

@Component({
  selector: 'conflict-handler-modal-comp',
  providers: [NgxSmartModalService],
  templateUrl: './conflict.handler.modal.component.html',
  styleUrls: ['./conflict.handler.modal.component.css']
})
export class ConflictHandlerModalComponent {

  @Output() onCancel = new EventEmitter();
  @Output() onResolved = new EventEmitter<Array<ImportConflict>>();
  
  // Get translation/text from customerJson
  private i18 = translateJson.i18;
  private conflicts: Array<ImportConflict> = [];
  private conflictForm: FormGroup;
  private errorMessage: string;

  constructor(private ngxSmartModalService: NgxSmartModalService) {
    
  }

  private createFormControls() {
    let group = {};
    this.conflicts.forEach(conflict => {
      group[conflict.title] = new FormControl(conflict.systemOption, conflict.validators);
    })
    this.conflictForm = new FormGroup(group);     
  }

  pop() {
    this.ngxSmartModalService.getModal('conflictHandlerModal').open();
  }

  close() {
    this.conflicts = [];
    this.errorMessage = null;
    this.ngxSmartModalService.getModal('conflictHandlerModal').close();
  }

  setConflicts(conflicts: Array<ImportConflict>) {
    this.conflicts = conflicts;
    this.createFormControls()
  }

  private onCancelClicked(): void {
    this.close();
    this.onCancel.next();
  }

  private onSubmitClicked(): void {
    this.conflicts.forEach(conflict => {
      conflict.resolution = this.conflictForm.get(conflict.title).value;
    })

    this.onResolved.next(this.conflicts)
  }

  displayError(error) {    
    this.errorMessage = `${error} (${this.i18.conflict.displayError2})`;
    this.scrollToTop();
  }

  closeError() {
    this.errorMessage = null;
  }

  scrollToTop() {
    let target = document.getElementById('scrollTarget');
    target.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}